module.exports = __webpack_public_path__ + "img/xk.bd62029e.svg";